import React, { useState, useCallback } from "react";
import _ from "lodash";

import { Link, useStaticQuery, graphql } from "gatsby";

import { Menu, MenuItem, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { getEntityUrl, getTranslatedTopbarEntities } from "../../util";

const MainMenu = (props) => {
    const { allStrapiAppSettings: settings, allStrapiEntities: entities } = useStaticQuery(staticQuery);
    
    const { locale: curLocale, defaultLocale } = props.pageContext || {};

    const translatedTopbarEntites = getTranslatedTopbarEntities(settings, entities, curLocale);
    
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = useCallback((e) => {
        e.stopPropagation();
        setAnchorEl(null);
    },[setAnchorEl]);

    return <>{translatedTopbarEntites.length > 0 && <>
        <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={handleMenu}
            size="large">
            <MenuIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose} getContentAnchorEl={null} keepMounted style={{zIndex: 65535 }}
              anchorOrigin={{ vertical: "bottom", horizontal: "right",}} >
            
            { translatedTopbarEntites?.map( e => 
                <MenuItem key={e.identifier} onClick={handleClose} component={Link} to={getEntityUrl({ entity: e, defaultLocale })}>
                    {e.title}
                </MenuItem>
            )}

        </Menu>
    </>}</>;
}

export default MainMenu;

const staticQuery = graphql`
    query {
                allStrapiAppSettings {
                    nodes {
                        Topbar {
                            languageSwitch
                            entities {
                                identifier
                                title
                                locale
                            }
                        }
                    }
                }
                allStrapiEntities {
                    nodes {
                        identifier
                        title
                        locale
                    }
                }
            }
    `;

